import { render, staticRenderFns } from "./nobalancelock.vue?vue&type=template&id=0ffcf390&scoped=true&"
import script from "./nobalancelock.vue?vue&type=script&lang=js&"
export * from "./nobalancelock.vue?vue&type=script&lang=js&"
import style0 from "./nobalancelock.vue?vue&type=style&index=0&id=0ffcf390&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcf390",
  null
  
)

export default component.exports